/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SaveSpecialDebtsRequest
 */
export interface SaveSpecialDebtsRequest {
    /**
     * 
     * @type {boolean}
     * @memberof SaveSpecialDebtsRequest
     */
    wasPreviouslySelfEmployed?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveSpecialDebtsRequest
     */
    isCurrentlySelfEmployed?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveSpecialDebtsRequest
     */
    hasBusinessLicense?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveSpecialDebtsRequest
     */
    exercisesTradeAsBusiness?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveSpecialDebtsRequest
     */
    isBusinessLicenseDormant?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveSpecialDebtsRequest
     */
    hasMaintenanceArrears?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveSpecialDebtsRequest
     */
    hasCriminalDebts?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveSpecialDebtsRequest
     */
    hasCreditDebts?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveSpecialDebtsRequest
     */
    creditWithinLastFiveYears?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof SaveSpecialDebtsRequest
     */
    creditRemark?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveSpecialDebtsRequest
     */
    hasMailOrderDebts?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveSpecialDebtsRequest
     */
    mailOrderWithinLastThreeYears?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof SaveSpecialDebtsRequest
     */
    mailOrderRemark?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveSpecialDebtsRequest
     */
    hasNeverPaidDebts?: boolean | null;
}

/**
 * Check if a given object implements the SaveSpecialDebtsRequest interface.
 */
export function instanceOfSaveSpecialDebtsRequest(value: object): value is SaveSpecialDebtsRequest {
    return true;
}

export function SaveSpecialDebtsRequestFromJSON(json: any): SaveSpecialDebtsRequest {
    return SaveSpecialDebtsRequestFromJSONTyped(json, false);
}

export function SaveSpecialDebtsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SaveSpecialDebtsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'wasPreviouslySelfEmployed': json['wasPreviouslySelfEmployed'] == null ? undefined : json['wasPreviouslySelfEmployed'],
        'isCurrentlySelfEmployed': json['isCurrentlySelfEmployed'] == null ? undefined : json['isCurrentlySelfEmployed'],
        'hasBusinessLicense': json['hasBusinessLicense'] == null ? undefined : json['hasBusinessLicense'],
        'exercisesTradeAsBusiness': json['exercisesTradeAsBusiness'] == null ? undefined : json['exercisesTradeAsBusiness'],
        'isBusinessLicenseDormant': json['isBusinessLicenseDormant'] == null ? undefined : json['isBusinessLicenseDormant'],
        'hasMaintenanceArrears': json['hasMaintenanceArrears'] == null ? undefined : json['hasMaintenanceArrears'],
        'hasCriminalDebts': json['hasCriminalDebts'] == null ? undefined : json['hasCriminalDebts'],
        'hasCreditDebts': json['hasCreditDebts'] == null ? undefined : json['hasCreditDebts'],
        'creditWithinLastFiveYears': json['creditWithinLastFiveYears'] == null ? undefined : json['creditWithinLastFiveYears'],
        'creditRemark': json['creditRemark'] == null ? undefined : json['creditRemark'],
        'hasMailOrderDebts': json['hasMailOrderDebts'] == null ? undefined : json['hasMailOrderDebts'],
        'mailOrderWithinLastThreeYears': json['mailOrderWithinLastThreeYears'] == null ? undefined : json['mailOrderWithinLastThreeYears'],
        'mailOrderRemark': json['mailOrderRemark'] == null ? undefined : json['mailOrderRemark'],
        'hasNeverPaidDebts': json['hasNeverPaidDebts'] == null ? undefined : json['hasNeverPaidDebts'],
    };
}

export function SaveSpecialDebtsRequestToJSON(json: any): SaveSpecialDebtsRequest {
    return SaveSpecialDebtsRequestToJSONTyped(json, false);
}

export function SaveSpecialDebtsRequestToJSONTyped(value?: SaveSpecialDebtsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'wasPreviouslySelfEmployed': value['wasPreviouslySelfEmployed'],
        'isCurrentlySelfEmployed': value['isCurrentlySelfEmployed'],
        'hasBusinessLicense': value['hasBusinessLicense'],
        'exercisesTradeAsBusiness': value['exercisesTradeAsBusiness'],
        'isBusinessLicenseDormant': value['isBusinessLicenseDormant'],
        'hasMaintenanceArrears': value['hasMaintenanceArrears'],
        'hasCriminalDebts': value['hasCriminalDebts'],
        'hasCreditDebts': value['hasCreditDebts'],
        'creditWithinLastFiveYears': value['creditWithinLastFiveYears'],
        'creditRemark': value['creditRemark'],
        'hasMailOrderDebts': value['hasMailOrderDebts'],
        'mailOrderWithinLastThreeYears': value['mailOrderWithinLastThreeYears'],
        'mailOrderRemark': value['mailOrderRemark'],
        'hasNeverPaidDebts': value['hasNeverPaidDebts'],
    };
}

